import { render } from "./UserEvent.vue?vue&type=template&id=4b3973a0"
import script from "./UserEvent.vue?vue&type=script&lang=js"
export * from "./UserEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__